import { useTheme } from 'styled-components';

import Button from '~components/Button';
import Pencil from '~components/Icon/Pencil';
import useGetCompanyInfo from '~hooks/query/company/useCompanyInfo';
import { useGetJobdomByCompanyQuery } from '~hooks/query/jobdom/useJobdom';
import { useRouterQuery } from '~hooks/useRouterQuery';
import useJobdomBoardStore from '~store/jobdom';

import * as S from './style';

export default function ButtonWriteBoard() {
  const companyId = useRouterQuery('companyId');
  const { data: companyInfo } = useGetCompanyInfo(companyId);
  const { refetch } = useGetJobdomByCompanyQuery(companyId);
  const { setModalJobEditor, resetModalJobEditor } = useJobdomBoardStore();

  const handleClick = () => {
    setModalJobEditor({
      open: true,
      mode: 'write',
      companyName: companyInfo?.name,
      PK_NM_HASH: companyId ?? '',
      onSuccess: () => {
        refetch();
        resetModalJobEditor();
      },
    });
  };

  return (
    <Button
      variant='light'
      size='sm'
      leading={<PencilIcon />}
      data-attribute-id='company__board__write__click'
      onClick={handleClick}>
      글쓰기
    </Button>
  );
}

function PencilIcon() {
  const theme = useTheme();

  return (
    <S.IconWrapper>
      <Pencil color={theme.colors.gray800} width={12} height={12} />
    </S.IconWrapper>
  );
}
